/* eslint-disable indent */
import { IQuizResultFilters, TQuizSortField } from '@sdk/contracts';
import { create } from 'zustand';

type TSortOrder = 'asc' | 'desc';

type QuizSortType = {
  [K in TQuizSortField]?: TSortOrder;
};
export const createQuizResultsStore = (defaultSort: QuizSortType) => {
  return create<{
    sort: QuizSortType;
    setSort: (sort: QuizSortType) => void;
    filters: IQuizResultFilters;
    setFilters: (filters: IQuizResultFilters) => void;
  }>(set => ({
    sort: defaultSort,
    setSort: sort => set({ sort }),
    filters: {},
    setFilters: filters => set({ filters })
  }));
};
